export const getAmount = (amount: number) => {
  if (amount) {
    const bigIntAmount = BigInt(amount) * BigInt(1e2);
    return Number(bigIntAmount) / 1e4;
  } else {
    return 0;
  }
};

export const getStripeAmount = (amount: string | number) => {
  const numberAmount = typeof amount === "number" ? amount : parseFloat(amount);
  if (!isNaN(numberAmount)) {
    return Math.round(numberAmount * 100);
  } else {
    return 0;
  }
};

export const getStripeAmounts = (amount: number) => {
  if (!isNaN(amount)) {
    return Math.round(amount * 100);
  } else {
    return 0;
  }
};

export const centsToDollars = (cents: number) => {
  return Number((cents / 100).toFixed(2));
};

export const washPrices = <T extends { price: number }>(priceObjects: T[]): T[] => {
  return priceObjects.map((priceObj) => {
    // Assuming the price is stored under a key named 'price' in each object
    let price = priceObj.price;

    // Check if the price has a decimal
    if (price.toString().includes(".")) {
      // Round to the nearest cent and remove the decimal
      price = Math.round(price * 100);
    } else {
      // If no decimal, append two zeroes
      price = price * 100;
    }

    // Update the price object
    const response = {
      ...priceObj,
      price: price,
    };

    return response;
  });
};

export const washPrice = (priceAmount: number) => {
  let price = priceAmount;

  // Check if the price has a decimal
  if (price.toString().includes(".")) {
    // Round to the nearest cent and remove the decimal
    price = Math.round(price * 100);
  } else {
    // If no decimal, append two zeroes
    price = price * 100;
  }

  return price;
};
